/**
 * Returns an array with double quotes.
 *
 * Japanese-specific quotes:
 * U300c - left corner bracket.
 * U300d - right corner bracket.
 * U300e - left white corner bracket.
 * U300f - right white corner bracket.
 *
 * @returns {string[]} The array with double quotes..
 */
export default [ "“", "”", "〝", "〞", "〟", "‟", "„", "\"", "\u300c", "\u300d", "\u300e", "\u300f" ];
